// extracted by mini-css-extract-plugin
module.exports = {"input":"Input_input__lvORT Text_base__DVupc undefined","disabled":"Input_disabled__R6iE2","label":"Input_label__CWIqo Text_base__DVupc undefined","prefix":"Input_prefix__0MJ_D"};